import { useMpMasonryWall } from '@borg/ui';

export default defineNuxtPlugin(async () => {
  useMpMasonryWall('index', 'visible').reset();
  useMpMasonryWall('index', 'hidden').reset();
  useMpMasonryWall('search', 'visible').reset();
  useMpMasonryWall('search', 'hidden').reset();
});
